import { fetchFerryService, fetchOrder, fetchUser } from 'services'
import { IntermediatePointType } from 'components/Order/constants'

export function fetchOrderAndFormRelatedData ({ orderId, fetchForwarder = true, fetchDispatcher = true }) {
  return fetchOrder(orderId)
    .then(order =>
      Promise.all([
        ...[fetchForwarder ? order.forwarderId : null,
          fetchDispatcher ? order.dispatcherId : null]
          .map(id => id != null
            ? fetchUser(id).catch(() => Promise.resolve(null))
            : Promise.resolve(null)
          ),
        ...(order.intermediatePoints
            .flatMap(series => series.points)
            .filter(ip => ip.type === IntermediatePointType.FerryPassage)
            .map(fp => fp.ferryServiceId)
            .filter(distinct)
            .map(id => fetchFerryService(id).catch(() => Promise.resolve(null)))
        )
      ])
        .then(([forwarder, dispatcher, ...ferryServices]) =>
          ({ order, forwarder, dispatcher, ferryServices: ferryServices.filter(service => service != null) })
        )
    )
}

function distinct (value, index, array) {
  return array.indexOf(value) === index
}
